import { getNewButtonCustomFontProperties } from 'client/pages/contact-us/entities/contact-us-button'
import { CustomFontProperties } from 'common/utils/fontsUtils'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { CustomFontsGenerator } from 'src/shared/utils/custom-fonts-generator'

export function getFormCustomFontProperties(entity: FormInterface) {
  const fontProperties: CustomFontProperties[] = []

  fontProperties.push(
    ...getNewButtonCustomFontProperties(entity.buttonCommonStyles),
  )
  fontProperties.push(
    ...CustomFontsGenerator.getBaseCustomFontProperties(
      entity.checkboxesCommonStyles,
    ),
  )

  return fontProperties
}
